var map = {
	"./adult/result-text.svg": 9977,
	"./confidence/result-text.svg": 6555,
	"./couples/result-text.svg": 5790,
	"./nice/result-text.svg": 9496,
	"./psycho/result-text.svg": 195,
	"./quirky/result-text.svg": 8272,
	"./rude/result-text.svg": 5133,
	"./sex/result-text.svg": 3217,
	"./spicy-couple/result-text.svg": 1540,
	"./spicy/result-text.svg": 7923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1193;